import { createStore } from 'redux';

import { AppReducer } from '../reducers/AppReducer';

// create the appstore and mount the middleware
const AppStore = createStore(AppReducer);

export default AppStore;
